import { HEADER_ORDER_SUCCESS_CONST } from './HeaderOrderSuccess.d';
import { HeaderOrderSuccess } from './HeaderOrderSuccess.styles';
import type { HeaderOrderProps } from './HeaderOrderSuccess.d';

const HeaderOrderSuccessBase = ({ children }: HeaderOrderProps) => (
  <HeaderOrderSuccess.Component data-testid={HEADER_ORDER_SUCCESS_CONST.TEST_ID}>
    {children}
  </HeaderOrderSuccess.Component>
);

export default HeaderOrderSuccessBase;
